import { render, staticRenderFns } from "./pending-orders.vue?vue&type=template&id=f5e61668&"
import script from "./pending-orders.vue?vue&type=script&lang=js&"
export * from "./pending-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports